import { useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import ArticleContent from './components/ArticleContent';
import RelatedArticles from './components/RelatedArticles';
import { getArticleBySlug, getRelatedArticles } from '@/mocks/articles';

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();

  if (!slug) {
    return (
      <>
        <Navbar />
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-20 text-center">
          <h1 className="text-2xl font-heading font-bold text-foreground-900">文章未找到</h1>
          <p className="mt-2 text-foreground-500">请选择有效的文章</p>
        </div>
        <Footer />
      </>
    );
  }

  const article = getArticleBySlug(slug);

  if (!article) {
    return (
      <>
        <Navbar />
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-20 text-center">
          <h1 className="text-2xl font-heading font-bold text-foreground-900">文章未找到</h1>
          <p className="mt-2 text-foreground-500">该文章可能已被删除或链接无效</p>
        </div>
        <Footer />
      </>
    );
  }

  const relatedArticles = getRelatedArticles(slug, article.category);

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <Breadcrumb
        items={[
          { label: article.categoryName, path: `/category/${article.category}` },
          { label: article.title },
        ]}
      />
      <main>
        <div className="w-full max-w-4xl mx-auto px-4 md:px-6 py-8">
          <ArticleContent
            title={article.title}
            categoryName={article.categoryName}
            category={article.category}
            date={article.date}
            author={article.author}
            readTime={article.readTime}
            imageUrl={article.imageUrl}
            contentHtml={article.content}
          />
          <RelatedArticles articles={relatedArticles} />
        </div>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Article',
            headline: article.title,
            description: article.excerpt,
            author: {
              '@type': 'Person',
              name: article.author,
            },
            datePublished: article.date,
            publisher: {
              '@type': 'Organization',
              name: '彩客网',
            },
            mainEntityOfPage: {
              '@type': 'WebPage',
              '@id': `https://www.caikewang.com/article/${slug}`,
            },
            inLanguage: 'zh-CN',
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: '首页',
                item: 'https://www.caikewang.com',
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: article.categoryName,
                item: `https://www.caikewang.com/category/${article.category}`,
              },
              {
                '@type': 'ListItem',
                position: 3,
                name: article.title,
                item: `https://www.caikewang.com/article/${slug}`,
              },
            ],
          }),
        }}
      />
    </>
  );
}